import { useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { UserContext } from "../Context/UserContext";

export const PartyIsSelect = ({
  selectedOption,
  setSelectedOption,
  changingSelect,
  setChangingSelect,
}) => {
  const { darkTheme, loginData } = useContext(UserContext);
  const initialOptions = [
    { value: "Individual", label: "Individual" },
    { value: "Proprietor", label: "Proprietor" },
    { value: "Partnership", label: "Partnership" },
    { value: "Company", label: "Company" },
  ];

  const [options, setOptions] = useState(initialOptions);

  useEffect(() => {
    const fetchOptions = async () => {
      if (selectedOption !== "") {
        const myFilter = options.filter(
          (item) => item.value === selectedOption
        );
        // const transformedOptions = myFilter.map((item) => ({
        //   value: item.value,
        //   label: item.value,
        // }));
        const myFind = myFilter.find((item) => item.value === selectedOption);
        if(myFind){
          setSelectedOption(myFind);
        }
      }
    };
    fetchOptions();
    setChangingSelect(false);
  }, [changingSelect]);

  // Custom styling
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "#fffa" : "#111a"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  return (
    <Select
      options={options}
      styles={customStyles}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select"
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      // defaultValue={options[0]}
    />
  );
};
